// store/socketStore.ts
import { create } from 'zustand';

interface SocketMessageState {
  messages: string[];
  connectionStatus: string;
  setMessages: (newMessages: string[]) => void;
  addMessage: (message: string) => void;
  setConnectionStatus: (status: string) => void;
}

const useSocketMessage = create<SocketMessageState>((set) => ({
  messages: [], // Holds the message received or sent
  connectionStatus: 'disconnected', // Holds the connection status (e.g., 'connected', 'disconnected')

  // Function to update the message
  setMessages: (newMessages) => set(() => ({ messages: newMessages })),
  
  // Function to add a single message to the list
  addMessage: (message) => set((state) => ({ messages: [...state.messages, message] })),

  // Function to update the connection status
  setConnectionStatus: (status) => set(() => ({ connectionStatus: status })),
}));

export default useSocketMessage;
